/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import { abs } from "mathjs";
import { t } from "../components/translate";

export const rupeeDisplay = (val: number, onlyValue = false): number | string => {
  if (val === null || val === undefined || Number.isNaN(val)) return "";
  if (val < 0) {
    val = abs(val).toString();
    let afterPoint = "";
    if (val.indexOf(".") > 0) afterPoint = val.substring(val.indexOf("."), val.length);
    val = Math.floor(val);
    val = val.toString();
    let lastThree = val.substring(val.length - 3);
    const otherNumbers = val.substring(0, val.length - 3);
    if (otherNumbers !== "") lastThree = `,${lastThree}`;
    const value = `-${otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",")}${lastThree}${afterPoint}`;
    return onlyValue ? value : `${t("rs")} ${value}`;
  }
  val = abs(val).toString();
  let afterPoint = "";
  if (val.indexOf(".") > 0) afterPoint = val.substring(val.indexOf("."), val.length);
  val = Math.floor(val);
  val = val.toString();
  let lastThree = val.substring(val.length - 3);
  const otherNumbers = val.substring(0, val.length - 3);
  if (otherNumbers !== "") lastThree = `,${lastThree}`;
  const value = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;

  return onlyValue ? value : `${t("rs")} ${value}`;
};

export const numberToWords = (price: number, tl = (a) => a, withCurrencyLabel = true): string => {
  const sglDigit = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
  const dblDigit = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen"
  ];
  const tensPlace = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety"
  ];
  const handleTens = function (dgt, prevDgt) {
    return dgt === 0 ? "" : ` ${dgt === 1 ? tl(dblDigit[prevDgt]) : tl(tensPlace[dgt])}`;
  };
  const handleUtlc = function (dgt, nxtDgt, denom) {
    return (
      (dgt !== 0 && nxtDgt !== 1 ? ` ${tl(sglDigit[dgt])}` : "") +
      (nxtDgt !== 0 || dgt > 0 ? ` ${denom}` : "")
    );
  };

  let str = "";
  let digitIdx = 0;
  let digit = 0;
  let nxtDigit = 0;
  const words = [];

  price += "";
  if (Number.isNaN(parseInt(price, 10))) return "";

  if (parseInt(price, 10) === 0) return `${tl("Zero")} ${tl("rupees")}`;
  const priceBrokenDown = price.split(".");
  // eslint-disable-next-line prefer-destructuring
  price = priceBrokenDown[0];
  let decimalPrice = priceBrokenDown[1];
  if (parseInt(price, 10) > 0 && price.length <= 10) {
    for (digitIdx = price.length - 1; digitIdx >= 0; digitIdx--)
      // eslint-disable-next-line default-case
      switch (
        ((digit = price[digitIdx] - 0),
        (nxtDigit = digitIdx > 0 ? price[digitIdx - 1] - 0 : 0),
        price.length - digitIdx - 1)
      ) {
        case 0:
          words.push(handleUtlc(digit, nxtDigit, ""));
          break;
        case 1:
          words.push(handleTens(digit, price[digitIdx + 1]));
          break;
        case 2:
          words.push(
            digit !== 0
              ? ` ${tl(sglDigit[digit])} ${tl("Hundred")}${
                  price[digitIdx + 1] !== 0 && price[digitIdx + 2] !== 0 ? ` ${tl("And")}` : ""
                }`
              : ""
          );
          break;
        case 3:
          words.push(handleUtlc(digit, nxtDigit, tl("Thousand")));
          break;
        case 4:
          words.push(handleTens(digit, price[digitIdx + 1]));
          break;
        case 5:
          words.push(handleUtlc(digit, nxtDigit, tl("Lakh")));
          break;
        case 6:
          words.push(handleTens(digit, price[digitIdx + 1]));
          break;
        case 7:
          words.push(handleUtlc(digit, nxtDigit, tl("Crore")));
          break;
        case 8:
          words.push(handleTens(digit, price[digitIdx + 1]));
          break;
        case 9:
          words.push(
            digit !== 0
              ? ` ${sglDigit[digit]} ${tl("Hundred")}${
                  price[digitIdx + 1] !== 0 || price[digitIdx + 2] !== 0
                    ? ` ${tl("And")}`
                    : ` ${tl("Crore")}`
                }`
              : ""
          );
      }
    str = words
      .reverse()
      .join("")
      .concat(withCurrencyLabel ? ` ${tl("rupees")}` : "");
  }
  if (parseInt(decimalPrice, 10) > 0 && decimalPrice.length) {
    decimalPrice = decimalPrice.padEnd(2, 0);
    str += ` ${tl("And")}  ${numberToWords(Number(decimalPrice), undefined, false)} ${tl("paisa")}`;
  }
  return str;
};
